import { render } from "./NotificationBanner.vue?vue&type=template&id=9b656d86&scoped=true&ts=true"
import script from "./NotificationBanner.vue?vue&type=script&lang=ts"
export * from "./NotificationBanner.vue?vue&type=script&lang=ts"

import "./NotificationBanner.vue?vue&type=style&index=0&id=9b656d86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b656d86"]])

export default __exports__